import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { AtlasModule } from '@galaxy/atlas';
import { CookieService } from 'ngx-cookie-service';
import { combineLatest, map, take } from 'rxjs';
import { FOLLOWING_VIEW_ID, InboxService } from '../../../core/src/index';
import { ViewModeService } from '../../../core/src/lib/view-mode.service';
import { ConversationPipesModule } from '../../../pipes/src/pipes.module';

const cookieKeyInboxDefaultOpen = 'inbox-default-open';

@Component({
  selector: 'inbox-button',
  standalone: true,
  styleUrls: ['./inbox-button.component.scss'],
  templateUrl: 'inbox-button.component.html',
  imports: [CommonModule, TranslateModule, MatIconModule, MatTooltipModule, AtlasModule, ConversationPipesModule],
})
export class InboxButtonComponent implements OnInit {
  readonly defaultViewId = FOLLOWING_VIEW_ID;
  constructor(
    private readonly viewModeService: ViewModeService,
    private readonly cookieService: CookieService,
    private readonly inboxService: InboxService,
  ) {}

  ngOnInit() {
    combineLatest([this.inboxService.openInboxDefault$, this.viewModeService.viewMode$])
      .pipe(
        map(([openDefault, viewMode]) => {
          const opened = this.getInboxDefaultOpen();
          if (viewMode === 'sidebar' && !opened && openDefault) {
            this.viewModeService.toggleInboxOpen();
            this.setInboxDefaultOpen();
          }
        }),
        take(1),
      )
      .subscribe();
  }
  readonly buttonSelected$ = this.viewModeService.isInboxOpen$.pipe(
    map((isOpen) => (isOpen ? 'atlas-navbar__item-selected' : '')),
  );

  toggle(): void {
    this.viewModeService.toggleInboxOpen();
  }

  private setInboxDefaultOpen(): void {
    this.cookieService.set(cookieKeyInboxDefaultOpen, 'opened');
  }

  private getInboxDefaultOpen(): string {
    return this.cookieService.get(cookieKeyInboxDefaultOpen);
  }
}
